import { CSSObject, styled, Typography } from "@mui/material";

export const TypographyWithEllipsis = styled(Typography)<{
  clamp?: number;
  onlyDesktop?: boolean;
}>(({ clamp, onlyDesktop, theme }) => {
  const styles: CSSObject = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: clamp || 5,
    WebkitBoxOrient: "vertical",
    [theme.breakpoints.up("md")]: {
      WebkitLineClamp: clamp || 3,
    },
  };
  return onlyDesktop
    ? {
        [theme.breakpoints.up("md")]: styles,
      }
    : styles;
});
